export default function MyBookings() {
  return (
    <div className="bg-white p-6 rounded shadow">
      <h2 className="text-xl font-bold text-orange-600 mb-4">My Bookings</h2>
      <p className="text-gray-600">No bookings found. Start planning your next trip!</p>
    </div>
  );
}